import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
    drawer: null,
    // user:true
    currentUser:null,
    // currentUser:{},
    user:null,
    statusUser:null,
    imprimerEmargement:false
  },
  getters:{
    isAuthenticated: (state) => !!state.user,
    statusUser: (state) => state.statusUser,
    currentUser: (state) => state.currentUser
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_USER(state, payload) {
      state.user = payload;
    },
    SET_CURRENT_USER(state, payload) {
      state.currentUser = payload;
    },
    SET_STATUS_USER(state, payload) {
      state.statusUser = payload;
    },
  },
  actions: {
      LogIn({commit}, data) {
       commit("SET_USER", data);
    },
      status({commit}, data) {
       commit("SET_STATUS_USER", data);
    },
  },
})
